/**
 * Vite-injected env. Vars must be prefixed with `VITE_` to be exposed.
 *
 * Set in apps/admin/.env (gitignored) for local dev:
 *   VITE_API_BASE_URL=http://127.0.0.1:8787
 *
 * In production (CF Pages), set via the Pages dashboard.
 */
export const env = {
  /** api-worker base URL. Empty string = same-origin (dev proxy). */
  apiBaseUrl: (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? '',
  /** Public app URL — used in success/cancel redirects. */
  appBaseUrl:
    (import.meta.env.VITE_APP_BASE_URL as string | undefined) ?? window.location.origin,
};
